import { render } from "./MRedemption.vue?vue&type=template&id=b9b43378&scoped=true&ts=true"
import script from "./MRedemption.vue?vue&type=script&lang=ts"
export * from "./MRedemption.vue?vue&type=script&lang=ts"

import "./MRedemption.vue?vue&type=style&index=0&id=b9b43378&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b43378"]])

export default __exports__